export function m2toFt2(m2, rounding = true) {
  let ft2 = m2 * 10.76391;
  return rounding ? Math.round(ft2 / 5) * 5 : ft2;
}

export function m2RangeToFt2Range(range, rounding = true) {
  return range
    .split('-')
    .map(m2 => m2toFt2(m2, rounding))
    .join('-');
}

export function isRange(value) {
  if (typeof value != 'string') return false;
  return value.split('-').length === 2;
}
